import React, { FunctionComponent } from 'react';
import { PieChart as RechartsPieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';

// data
import { colors } from 'data/colors';

// utils
import formatNumber from 'utils/formatNumber';

// components
import CustomTooltip from '../CustomTooltip';

interface Props {
  data: any;
  totalItems?: number;
}

const PieChart: FunctionComponent<Props> = ({ data, totalItems }) => (
  <ResponsiveContainer height={370} width="100%">
    <RechartsPieChart>
      <Pie data={data} isAnimationActive dataKey="value">
        {data.map((entry: any, index: number) => (
          <Cell key={index} fill={colors[index % colors.length]} />
        ))}
      </Pie>
      <Legend
        payload={data.map((entry: { key: string; value: string; country: string }, index: number) => {
          const legendCountry = (entry.key || entry.country || 'N/A').toUpperCase();
          return {
            id: index,
            value: `${legendCountry}: ${formatNumber(Number(entry.value))}`,
            type: 'square',
            color: colors[index % colors.length],
          };
        })}
      />
      <Tooltip content={<CustomTooltip totalItems={totalItems} />} />
    </RechartsPieChart>
  </ResponsiveContainer>
);

export default PieChart;
